// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssid-details-container {
    width: 655px;
    height: 420px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 5px;
    margin: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
.APNAME{
    position: relative; /* 使用绝对定位 */
    left: 70px; /* 设置离左侧距离为 75px */
    top: -50px; /* 设置离顶部距离为 50px */
    color: #333; /* 文字颜色 */
    font-size: 28px; /* 字体大小 */
    font-weight: bold; /* 字体加粗 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    white-space: nowrap; /* 禁止换行 */
    white-space: nowrap; /* 防止内容换行 */
    text-overflow: ellipsis; /* 文本超出部分用省略号表示 */
    width: 380px; /* 设置宽度 */
  }

  .APStatust{
    position: relative; /* 使用绝对定位 */
    font-size: 18px; /* 字体大小 */
    left: 0px; /* 设置离左侧距离为 0px */
    top: -40px; /* 设置离顶部距离为 40px */
}
  .APStatusttitle{
      position: relative; /* 使用绝对定位 */
      font-size: 18px; /* 字体大小 */
      font-weight: bold; /* 字体加粗 */
      left: 0px; /* 设置离左侧距离为 0px */
      top: -30px; /* 设置离顶部距离为 40px */
  }

.SSID2{
  position: relative; /* 使用绝对定位 */
  font-size: 24px; /* 字体大小 */
  left: -20px; /* 设置离左侧距离为 0px */
  top: -25px; /* 设置离顶部距离为 40px */
  margin: 20px
}
.details{
  position: relative; /* 使用绝对定位 */
  font-size: 18px; /* 字体大小 */
  left: 5px; /* 设置离左侧距离为 0px */
  top: -25px; /* 设置离顶部距离为 40px */
  margin: 20px
}

.formatLastSeenTime{
  position: relative; /* 使用绝对定位 */
  font-size: 18px; /* 字体大小 */
  left: -10px; /* 设置离左侧距离为 0px */
  top: -5px; /* 设置离顶部距离为 40px */
  margin: 10px
}

.back-button{
  position: absolute; 
  left: 128px; /* 设置离左侧距离为 0px */
  top: 1080px; /* 设置离顶部距离为 40px */

}
.strongestApName{
  color: #006eff;
  font-weight: bold;
}


.ssid-details {
  width: 655px;
}

.additional-details-box{
  width: 655px;
  height: 66px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.additional-details-box-clients{
  width: 655px;
  height: 44px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.Title{
  position: relative; /* 使用绝对定位 */
  left: 70px; /* 设置离左侧距离为 75px */
  top: -50px; /* 设置离顶部距离为 50px */
  color: #333; /* 文字颜色 */
  font-size: 32px; /* 字体大小 */
  font-weight: bold; /* 字体加粗 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  white-space: nowrap; /* 禁止换行 */
  white-space: nowrap; /* 防止内容换行 */
  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */
  width: 380px; /* 设置宽度 */
}

.Title-clients{
  position: relative; /* 使用绝对定位 */
  left: 70px; /* 设置离左侧距离为 75px */
  top: -50px; /* 设置离顶部距离为 50px */
  color: #333; /* 文字颜色 */
  font-size: 32px; /* 字体大小 */
  font-weight: bold; /* 字体加粗 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  white-space: nowrap; /* 禁止换行 */
  white-space: nowrap; /* 防止内容换行 */
  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */
  width: 380px; /* 设置宽度 */
}

/* 定义more-icon位置 */
.more-icon{
  position: relative; /* 使用绝对定位 */
  top: 10px; /* 距离顶部 48px */
  right: -600px; /* 距离右侧 15px */
}
.count {
  position: relative; /* 使用绝对定位 */
  top: -62px; /* 距离顶部 85px */
  right: -610px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 20px; /* 字体大小 */
  white-space: nowrap; /* 防止文本换行 */
}

/* 定义more-icon位置 */
.more-icon-clients{
  position: relative; /* 使用绝对定位 */
  top: 0px; /* 距离顶部 48px */
  right: -600px; /* 距离右侧 15px */
}
.count-clients{
  position: relative; /* 使用绝对定位 */
  top: -72px; /* 距离顶部 85px */
  right: -610px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 20px; /* 字体大小 */
  white-space: nowrap; /* 防止文本换行 */
}

/* 定义选中的子标题 */
.selectematched {
  position: relative; /* 使用绝对定位 */
  top: -65px; /* 距离顶部 85px */
  left: 0px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 18px; /* 字体大小 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  white-space: nowrap; /* 禁止换行 */
  white-space: nowrap; /* 防止内容换行 */
  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */
  width: 480px; /* 设置宽度 */
}`, "",{"version":3,"sources":["webpack://./src/css/APsDetails.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;EAC1C;;AAEF;IACI,kBAAkB,EAAE,WAAW;IAC/B,UAAU,EAAE,kBAAkB;IAC9B,UAAU,EAAE,kBAAkB;IAC9B,WAAW,EAAE,SAAS;IACtB,eAAe,EAAE,SAAS;IAC1B,iBAAiB,EAAE,SAAS;IAC5B,gBAAgB,EAAE,cAAc;IAChC,mBAAmB,EAAE,SAAS;IAC9B,mBAAmB,EAAE,WAAW;IAChC,uBAAuB,EAAE,iBAAiB;IAC1C,YAAY,EAAE,SAAS;EACzB;;EAEA;IACE,kBAAkB,EAAE,WAAW;IAC/B,eAAe,EAAE,SAAS;IAC1B,SAAS,EAAE,iBAAiB;IAC5B,UAAU,EAAE,kBAAkB;AAClC;EACE;MACI,kBAAkB,EAAE,WAAW;MAC/B,eAAe,EAAE,SAAS;MAC1B,iBAAiB,EAAE,SAAS;MAC5B,SAAS,EAAE,iBAAiB;MAC5B,UAAU,EAAE,kBAAkB;EAClC;;AAEF;EACE,kBAAkB,EAAE,WAAW;EAC/B,eAAe,EAAE,SAAS;EAC1B,WAAW,EAAE,iBAAiB;EAC9B,UAAU,EAAE,kBAAkB;EAC9B;AACF;AACA;EACE,kBAAkB,EAAE,WAAW;EAC/B,eAAe,EAAE,SAAS;EAC1B,SAAS,EAAE,iBAAiB;EAC5B,UAAU,EAAE,kBAAkB;EAC9B;AACF;;AAEA;EACE,kBAAkB,EAAE,WAAW;EAC/B,eAAe,EAAE,SAAS;EAC1B,WAAW,EAAE,iBAAiB;EAC9B,SAAS,EAAE,kBAAkB;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,iBAAiB;EAC9B,WAAW,EAAE,kBAAkB;;AAEjC;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,kBAAkB;EAC9B,UAAU,EAAE,kBAAkB;EAC9B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB,EAAE,WAAW;EAChC,uBAAuB,EAAE,iBAAiB;EAC1C,YAAY,EAAE,SAAS;AACzB;;AAEA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,kBAAkB;EAC9B,UAAU,EAAE,kBAAkB;EAC9B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB,EAAE,WAAW;EAChC,uBAAuB,EAAE,iBAAiB;EAC1C,YAAY,EAAE,SAAS;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,WAAW;EAC/B,SAAS,EAAE,cAAc;EACzB,aAAa,EAAE,cAAc;AAC/B;AACA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,aAAa,EAAE,cAAc;EAC7B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,mBAAmB,EAAE,WAAW;AAClC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,WAAW;EAC/B,QAAQ,EAAE,cAAc;EACxB,aAAa,EAAE,cAAc;AAC/B;AACA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,aAAa,EAAE,cAAc;EAC7B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,mBAAmB,EAAE,WAAW;AAClC;;AAEA,aAAa;AACb;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,SAAS,EAAE,cAAc;EACzB,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB,EAAE,WAAW;EAChC,uBAAuB,EAAE,iBAAiB;EAC1C,YAAY,EAAE,SAAS;AACzB","sourcesContent":[".ssid-details-container {\r\n    width: 655px;\r\n    height: 420px;\r\n    padding: 20px;\r\n    background-color: #ffffff;\r\n    border-radius: 5px;\r\n    margin: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n.APNAME{\r\n    position: relative; /* 使用绝对定位 */\r\n    left: 70px; /* 设置离左侧距离为 75px */\r\n    top: -50px; /* 设置离顶部距离为 50px */\r\n    color: #333; /* 文字颜色 */\r\n    font-size: 28px; /* 字体大小 */\r\n    font-weight: bold; /* 字体加粗 */\r\n    overflow: hidden; /* 隐藏超出容器的内容 */\r\n    white-space: nowrap; /* 禁止换行 */\r\n    white-space: nowrap; /* 防止内容换行 */\r\n    text-overflow: ellipsis; /* 文本超出部分用省略号表示 */\r\n    width: 380px; /* 设置宽度 */\r\n  }\r\n\r\n  .APStatust{\r\n    position: relative; /* 使用绝对定位 */\r\n    font-size: 18px; /* 字体大小 */\r\n    left: 0px; /* 设置离左侧距离为 0px */\r\n    top: -40px; /* 设置离顶部距离为 40px */\r\n}\r\n  .APStatusttitle{\r\n      position: relative; /* 使用绝对定位 */\r\n      font-size: 18px; /* 字体大小 */\r\n      font-weight: bold; /* 字体加粗 */\r\n      left: 0px; /* 设置离左侧距离为 0px */\r\n      top: -30px; /* 设置离顶部距离为 40px */\r\n  }\r\n\r\n.SSID2{\r\n  position: relative; /* 使用绝对定位 */\r\n  font-size: 24px; /* 字体大小 */\r\n  left: -20px; /* 设置离左侧距离为 0px */\r\n  top: -25px; /* 设置离顶部距离为 40px */\r\n  margin: 20px\r\n}\r\n.details{\r\n  position: relative; /* 使用绝对定位 */\r\n  font-size: 18px; /* 字体大小 */\r\n  left: 5px; /* 设置离左侧距离为 0px */\r\n  top: -25px; /* 设置离顶部距离为 40px */\r\n  margin: 20px\r\n}\r\n\r\n.formatLastSeenTime{\r\n  position: relative; /* 使用绝对定位 */\r\n  font-size: 18px; /* 字体大小 */\r\n  left: -10px; /* 设置离左侧距离为 0px */\r\n  top: -5px; /* 设置离顶部距离为 40px */\r\n  margin: 10px\r\n}\r\n\r\n.back-button{\r\n  position: absolute; \r\n  left: 128px; /* 设置离左侧距离为 0px */\r\n  top: 1080px; /* 设置离顶部距离为 40px */\r\n\r\n}\r\n.strongestApName{\r\n  color: #006eff;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.ssid-details {\r\n  width: 655px;\r\n}\r\n\r\n.additional-details-box{\r\n  width: 655px;\r\n  height: 66px;\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  border-radius: 5px;\r\n  margin: 10px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n.additional-details-box-clients{\r\n  width: 655px;\r\n  height: 44px;\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  border-radius: 5px;\r\n  margin: 10px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.Title{\r\n  position: relative; /* 使用绝对定位 */\r\n  left: 70px; /* 设置离左侧距离为 75px */\r\n  top: -50px; /* 设置离顶部距离为 50px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 32px; /* 字体大小 */\r\n  font-weight: bold; /* 字体加粗 */\r\n  overflow: hidden; /* 隐藏超出容器的内容 */\r\n  white-space: nowrap; /* 禁止换行 */\r\n  white-space: nowrap; /* 防止内容换行 */\r\n  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */\r\n  width: 380px; /* 设置宽度 */\r\n}\r\n\r\n.Title-clients{\r\n  position: relative; /* 使用绝对定位 */\r\n  left: 70px; /* 设置离左侧距离为 75px */\r\n  top: -50px; /* 设置离顶部距离为 50px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 32px; /* 字体大小 */\r\n  font-weight: bold; /* 字体加粗 */\r\n  overflow: hidden; /* 隐藏超出容器的内容 */\r\n  white-space: nowrap; /* 禁止换行 */\r\n  white-space: nowrap; /* 防止内容换行 */\r\n  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */\r\n  width: 380px; /* 设置宽度 */\r\n}\r\n\r\n/* 定义more-icon位置 */\r\n.more-icon{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: 10px; /* 距离顶部 48px */\r\n  right: -600px; /* 距离右侧 15px */\r\n}\r\n.count {\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -62px; /* 距离顶部 85px */\r\n  right: -610px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 20px; /* 字体大小 */\r\n  white-space: nowrap; /* 防止文本换行 */\r\n}\r\n\r\n/* 定义more-icon位置 */\r\n.more-icon-clients{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: 0px; /* 距离顶部 48px */\r\n  right: -600px; /* 距离右侧 15px */\r\n}\r\n.count-clients{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -72px; /* 距离顶部 85px */\r\n  right: -610px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 20px; /* 字体大小 */\r\n  white-space: nowrap; /* 防止文本换行 */\r\n}\r\n\r\n/* 定义选中的子标题 */\r\n.selectematched {\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -65px; /* 距离顶部 85px */\r\n  left: 0px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 18px; /* 字体大小 */\r\n  overflow: hidden; /* 隐藏超出容器的内容 */\r\n  white-space: nowrap; /* 禁止换行 */\r\n  white-space: nowrap; /* 防止内容换行 */\r\n  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */\r\n  width: 480px; /* 设置宽度 */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
